
define('text!TescoMobile_Customer/template/account/dashboard/loyalty-bundle.html',[],function () { return '<!-- ko if: loyaltyBundle().current_loyalty_bundle --><div class="customer-account-grid-tile-row"><div class="detail"><span class="customer-dashboard-loyalty-bundle" data-bind="text: loyaltyBundle().current_loyalty_bundle"></span></div></div><!-- /ko -->';});

